<div class="content-card-container-bg">
  <div class="content-card-container">
    <div class="content-card text-align-center">
      <div>
        <img src="assets/images/flamingo.svg" alt="pascom welcome picture">
      </div>
      <div>
        @if (headline) {
          <h1>{{ headline | i18next}}</h1>
        }
        @if (content) {
          <p class="gray">{{ content | i18next}}</p>
        }
        @if (documentation) {
          <span class="btn btn-link no-border" (click)="onOpenDocumentation()">{{ documentation | i18next }}</span>
        }
        <div class="mt-3 mb-3">
          @if (showBackrouteButton) {
            <button class="btn btn-outline-primary" (click)="onOpenBackroute()">{{ backrouteButton | i18next }}</button>
          }
        </div>
      </div>
    </div>
  </div>
</div>
